import React from 'react'
import Title from "../components/Title";
import CardMention from "../components/CardMention";
import Category from "../components/Category";
import Pub from "../components/Pub";
import {Helmet} from 'react-helmet';
import PathwaysList from "../components/PathwaysList";

function Home() {
    return (
        <>
            <Helmet>
                <title>Tisradar - Formation en Télédétection Radar et LIDAR</title>
                <meta name="description"
                      content="Plateforme éducative dédiée à l'apprentissage du traitement d'images radar et LIDAR. Découvrez nos cours, ressources et formations en français et malgache."/>
                <link rel="canonical" href="https://tisradar.hiqaody.me/"/>
            </Helmet>
            <main className="App">
                <header>
                    <Title/>
                </header>
                <section className="hidden sm:block md:hidden xl:block" aria-label="Mentions spéciales">
                    <CardMention/>
                </section>
                <section aria-label="Publications">
                    <Pub/>
                </section>
                <section aria-label="Catégories de cours">
                    <Category/>
                </section>
                <section aria-label="Livres et ressources">
                    <PathwaysList />
                </section>
                
            </main>
        </>
    )
}

export default Home
